export default {"src":"/_next/static/media/background.d10ac8cb.svg","height":730,"width":1440,"blurWidth":0,"blurHeight":0};